export const articles = [
  {
    id: 1,
    title: '深夜焦虑怎么办？凌晨不打烊帮你找回内心平静',
    summary: '凌晨时分，城市的喧嚣渐渐褪去，但内心的焦虑却开始蔓延。本文为你分享几个深夜缓解焦虑的实用方法，让你在凌晨也能找到内心的安宁。',
    content: `<p>凌晨两点，你躺在床上翻来覆去，脑子里却像开了锅一样停不下来。工作的压力、生活的琐事、未来的不确定……在深夜的寂静中，这些焦虑被无限放大。</p>
<p>这不是你一个人的困扰。据调查，超过65%的城市白领曾经历过"深夜焦虑"，而凌晨1-3点正是焦虑情绪的高发时段。</p>
<h3>为什么深夜容易焦虑？</h3>
<p>从生理学角度看，深夜时分人体的皮质醇水平自然下降，褪黑素开始分泌，这本应是身体准备入睡的信号。但当大脑处于过度活跃状态时，这种生理变化反而会加剧心理上的不适感。</p>
<p>从心理学角度，深夜是一个"社会性孤独"的时刻——朋友圈不再更新、群聊归于沉寂、整座城市仿佛只剩下你一个人醒着。这种孤独感会让负面情绪更容易放大。</p>
<h3>凌晨不打烊的建议</h3>
<p><strong>1. 接纳而非对抗</strong>：焦虑本身不是敌人，对抗焦虑才是。试着对自己说："我注意到自己有些焦虑，这很正常。"接纳当下的感受，它反而会慢慢消退。</p>
<p><strong>2. 书写疗法</strong>：拿出一张纸（或者手机备忘录），把脑子里所有乱七八糟的想法全部写下来。不用整理，不用修饰，就让它流淌出来。这个简单的动作能把焦虑从大脑"卸载"到纸上。</p>
<p><strong>3. 4-7-8呼吸法</strong>：吸气4秒，憋气7秒，缓慢呼气8秒。重复5次。这个方法能激活副交感神经系统，快速让身体进入放松状态。</p>
<p><strong>4. 寻找深夜陪伴</strong>：凌晨不打烊的在线心理咨询服务24小时开放。当你觉得难以独自承受时，专业的心理咨询师会在深夜守候，倾听你的心事，陪伴你度过最难熬的时刻。</p>
<p>记住，深夜的焦虑并不代表你软弱，恰恰相反，它说明你对生活有期待、对自己有要求。给自己一点耐心和温柔，每个凌晨熬过之后，太阳都会照常升起。</p>`,
    category: 'consulting',
    imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20bedroom%20at%20night%20with%20soft%20moonlight%20through%20window%2C%20person%20sitting%20calmly%20on%20bed%20in%20meditation%2C%20warm%20cozy%20atmosphere%2C%20gentle%20ambient%20glow%2C%20minimal%20modern%20interior%2C%20serene%20and%20calming%20mood&width=800&height=400&seq=article-anxiety&orientation=landscape',
    date: '2026-08-05',
    readTime: '8分钟',
    author: '凌晨不打烊编辑部',
    tags: ['深夜焦虑', '心理健康', '失眠'],
  },
  {
    id: 2,
    title: '凌晨急送背后的故事：那些深夜奔跑的人',
    summary: '当城市沉睡时，有一群人依然在街头穿梭。他们是凌晨不打烊的配送员，用深夜的速度守护着每一个紧急需求。来看看他们不为人知的故事。',
    content: `<p>凌晨三点，整座城市笼罩在深蓝色的夜幕中。街灯孤零零地亮着，偶尔一辆车驶过，划破寂静。但在凌晨不打烊的配送中心，这里依然灯火通明。</p>
<p>小刘是凌晨不打烊的一名配送员，今年是他从事深夜配送的第三年。"很多人觉得凌晨配送很辛苦，确实辛苦，但每次看到用户收到急需物品时那种如释重负的表情，就觉得一切都值了。"</p>
<h3>一碗热粥的温度</h3>
<p>小刘印象最深的一次配送，是去年冬天的一个凌晨。一位独居老人突发肠胃不适，在凌晨不打烊平台下单了一碗白粥和胃药。小刘接到订单后，特意绕路去了一家24小时粥铺，确保粥是热腾腾的。</p>
<p>"老人开门的时候手都在发抖，看到热粥眼眶就红了。他说子女都在外地，凌晨难受不知道找谁，没想到真的有人送过来。那一刻我突然明白，我送的不仅仅是一碗粥。"</p>
<h3>凌晨不打烊的承诺</h3>
<p>在凌晨不打烊，像小刘这样的配送员有上千人，分布在城市的各个角落。他们中有兼职补贴家用的上班族，有白天带娃晚上跑单的年轻妈妈，也有希望通过努力改善生活的年轻人。</p>
<p>平台为他们提供了完善的保障：夜间配送补贴、安全保险、防寒防暑物资，以及24小时在线的调度支持。因为我们相信，只有守护好服务者，他们才能更好地守护用户。</p>
<h3>凌晨速度的背后</h3>
<p>30分钟送达的承诺背后，是智能调度系统的精准计算、是仓储中心的高效运转、是每一位配送员争分夺秒的奔跑。凌晨不打烊用技术和服务，把深夜的无助变成了温暖的确幸。</p>
<p>下次在凌晨收到包裹时，不妨对配送员说一声谢谢。深夜的每一次奔跑，都值得被看见和尊重。</p>`,
    category: 'delivery',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delivery%20rider%20on%20scooter%20riding%20through%20empty%20city%20street%20at%20night%2C%20warm%20golden%20street%20lights%20reflecting%20on%20wet%20road%2C%20urban%20night%20scene%2C%20motion%20blur%20effect%2C%20cinematic%20mood%2C%20quiet%20dedicated%20atmosphere&width=800&height=400&seq=article-delivery&orientation=landscape',
    date: '2026-08-03',
    readTime: '6分钟',
    author: '凌晨不打烊编辑部',
    tags: ['凌晨配送', '配送员故事', '深夜服务'],
  },
  {
    id: 3,
    title: '24小时服务的正确打开方式：这些深夜服务你可能不知道',
    summary: '凌晨不打烊不只是送外卖！从心理咨询到紧急维修，我们整理了10个你可能不知道但超实用的深夜服务，让你的凌晨不再无助。',
    content: `<p>提到凌晨服务，大多数人第一反应是"送外卖"。其实远不止于此！凌晨不打烊整合了六大品类、数十种细分服务，覆盖你深夜可能遇到的绝大部分需求。今天就来盘点那些"真香"但你可能还不知道的深夜服务。</p>
<h3>1. 深夜心理咨询——凌晨的情绪树洞</h3>
<p>凌晨是情绪最脆弱的时刻，也是心理咨询需求的高峰期。我们的心理咨询师团队由持证专业人士组成，提供语音和文字两种咨询方式，确保你在最需要的时候有人倾听。</p>
<h3>2. 紧急开锁服务——凌晨的"救命稻草"</h3>
<p>加班到凌晨回家发现钥匙忘在办公室？出门倒垃圾被反锁在门外？深夜开锁师傅20分钟上门，不用砸门、不用爬窗，专业工具无损开锁。</p>
<h3>3. 宠物急诊陪护——毛孩子的深夜守护者</h3>
<p>凌晨宠物突发呕吐、腹泻？别慌，在线兽医快速判断紧急程度，需要时安排24小时宠物医院对接，全程陪护你的毛孩子。</p>
<h3>4. IT紧急支援——凌晨的"技术救火队"</h3>
<p>网站凌晨宕机、数据库崩溃、被黑客攻击……技术团队7×24小时在线，比你的闹钟还靠谱。深夜的技术故障，交给凌晨不打烊的技术团队来处理。</p>
<h3>5. 法律应急咨询——凌晨的法律护盾</h3>
<p>凌晨遇到交通事故纠纷？被深夜噪音扰民不知道怎么办？律师在线解答，帮你第一时间固定证据、理清法律关系。</p>
<p>凌晨不打烊的全天候服务体系，就是让你在任何时间遇到任何问题，都有一个可以信赖的依靠。深夜不是只能独自硬扛，凌晨不打烊一直在。</p>`,
    category: 'life',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20various%20service%20app%20icons%20at%20night%2C%20warm%20hand%20holding%20phone%2C%20cozy%20bedroom%20background%20with%20soft%20lamp%20light%2C%20modern%20digital%20lifestyle%2C%20convenient%20night%20service%20concept&width=800&height=400&seq=article-services&orientation=landscape',
    date: '2026-07-28',
    readTime: '7分钟',
    author: '凌晨不打烊编辑部',
    tags: ['深夜服务', '全天候服务', '实用指南'],
  },
  {
    id: 4,
    title: '凌晨不打烊用户故事：那些凌晨时刻的温暖瞬间',
    summary: '从深夜加班族的暖心夜宵到凌晨急诊的紧急送药，真实用户分享他们与凌晨不打烊的故事，每一个都是凌晨城市里最温暖的光。',
    content: `<p>凌晨不打烊上线三年，服务了超过500万用户。每一个凌晨的订单背后，都有一个真实的故事。今天，我们邀请了三位用户来分享他们与凌晨不打烊的温暖回忆。</p>
<h3>故事一：深夜加班族的"救命"夜宵</h3>
<p>@小林（互联网运营）："那天赶项目到凌晨两点，饿得胃疼，冰箱空空如也。试着在凌晨不打烊下了个夜宵单，没想到20分钟就送到了。热乎乎的牛肉面打开的那一刻，眼泪都快下来了。那种'凌晨还有人惦记你'的感觉，真的暖到心里。"</p>
<h3>故事二：新手妈妈的凌晨求助</h3>
<p>@豆豆妈（新手妈妈）："宝宝凌晨突然发高烧，老公出差不在家，我一个人抱着孩子慌得不行。在凌晨不打烊上问了在线医生，医生很耐心地指导我物理降温，还帮我联系了最近的24小时药店送药。那些专业的指导在那个凌晨给了我巨大的安心。"</p>
<h3>故事三：独居老人的深夜依靠</h3>
<p>@老张（退休教师，68岁）："子女都在国外，我一个人住。有次凌晨心慌得厉害，不敢睡觉。试着拨了凌晨不打烊的心理咨询热线，那个小姑娘陪我说了整整一个小时的话，从年轻时的教书经历聊到现在的独居生活。那天凌晨聊完之后，我睡得特别踏实。"</p>
<h3>每一个凌晨都值得被温柔以待</h3>
<p>这些故事每天都在发生。凌晨不打烊不只是一个服务平台，更是深夜城市中的一盏灯——告诉每一个在凌晨醒着的人：你不是一个人。</p>
<p>无论你是因为加班、失眠、焦虑、突发状况还是其他任何原因在凌晨需要帮助，凌晨不打烊都在这里，24小时不打烊，用心陪伴每一个凌晨。</p>`,
    category: 'life',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20glowing%20light%20from%20apartment%20window%20in%20dark%20city%20skyline%20at%20night%2C%20one%20bright%20lit%20window%20among%20dark%20buildings%2C%20symbol%20of%20hope%20and%20companionship%2C%20urban%20night%20scene%2C%20cinematic%20atmosphere&width=800&height=400&seq=article-stories&orientation=landscape',
    date: '2026-07-25',
    readTime: '7分钟',
    author: '凌晨不打烊编辑部',
    tags: ['用户故事', '深夜温暖', '真实经历'],
  },
  {
    id: 5,
    title: '凌晨运动伤害急救指南：深夜健身达人必看',
    summary: '越来越多的年轻人选择凌晨健身，但凌晨运动受伤后怎么办？凌晨不打烊为你整理了一份深夜运动伤害急救手册，建议收藏。',
    content: `<p>凌晨健身正在成为都市年轻人的新潮流——避开健身房高峰、享受独处的运动时光。但凌晨运动也伴随着一个风险：受伤了怎么办？医院急诊太远、朋友都在睡觉……</p>
<h3>常见凌晨运动伤害及处理</h3>
<p><strong>肌肉拉伤</strong>：立即停止运动，采用RICE原则——Rest（休息）、Ice（冰敷）、Compression（加压包扎）、Elevation（抬高患肢）。冰敷每次15-20分钟，间隔2小时。凌晨不打烊可配送冰袋和弹性绷带上门。</p>
<p><strong>踝关节扭伤</strong>：不要揉搓！先冷敷减少肿胀，用弹性绷带固定。如果肿胀严重或无法承重，可能涉及骨折，需要紧急处理。凌晨不打烊的在线问诊可以帮助判断是否需要立即就医。</p>
<p><strong>肌肉痉挛（抽筋）</strong>：反向拉伸痉挛肌肉，保持15-30秒。小腿抽筋时坐在地上腿伸直，用手抓住脚趾向身体方向拉。补充电解质——凌晨不打烊可配送运动饮料和香蕉。</p>
<h3>凌晨健身安全建议</h3>
<p>1. 充分热身：凌晨体温较低，肌肉粘滞性大，热身时间要比白天延长5-10分钟</p>
<p>2. 不要空腹：运动前30分钟补充少量碳水化合物</p>
<p>3. 保持通讯：手机保持充足电量，告知至少一位朋友你的运动地点</p>
<p>4. 随身携带身份信息：万一出现意外，救援人员能快速获取你的基本信息</p>
<p>5. 下载凌晨不打烊：无论凌晨几点，一键呼叫紧急支援</p>`,
    category: 'medical',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20gym%20at%20night%20with%20one%20person%20stretching%20on%20yoga%20mat%2C%20warm%20dim%20lighting%2C%20fitness%20equipment%20in%20background%2C%20clean%20minimal%20space%2C%20night%20city%20view%20through%20large%20windows%2C%20peaceful%20workout%20atmosphere&width=800&height=400&seq=article-fitness&orientation=landscape',
    date: '2026-07-20',
    readTime: '5分钟',
    author: '凌晨不打烊健康组',
    tags: ['凌晨健身', '运动急救', '健康指南'],
  },
  {
    id: 6,
    title: '凌晨不打烊发布2026夜间服务报告：深夜经济崛起',
    summary: '凌晨不打烊发布年度夜间服务大数据报告，揭示了中国深夜消费的最新趋势。凌晨3点竟然是最活跃时段？这些数据让人意想不到。',
    content: `<p>凌晨不打烊联合多家研究机构发布了《2026年中国夜间服务消费白皮书》，基于平台千万级订单数据，全面揭示了深夜经济的最新趋势。</p>
<h3>核心发现</h3>
<p><strong>1. 凌晨3点是最活跃时段</strong>：与普遍认为的"凌晨1点后无人活动"相反，数据显示凌晨3点是夜间服务订单的高峰时段，约占全天订单的8%。</p>
<p><strong>2. 深夜心理咨询需求增长300%</strong>：相比去年，凌晨时段的心理咨询订单量增长了300%，反映出都市人群精神健康意识的提升。</p>
<p><strong>3. 凌晨配送主力军：25-35岁都市白领</strong>：深夜下单用户中，25-35岁群体占比62%，其中女性用户占比58%高于男性。</p>
<p><strong>4. "深夜急送"品类最受欢迎</strong>：药品、热食、文件是凌晨急送TOP3品类，平均送达时间28分钟。</p>
<p><strong>5. 新一线城市深夜消费增速超一线</strong>：成都、杭州、长沙等新一线城市的深夜服务订单增速已经超过北上广深。</p>
<h3>深夜经济的未来</h3>
<p>随着都市生活节奏的加快和灵活就业模式的普及，深夜经济正成为不可忽视的增长极。凌晨不打烊将继续深耕夜间服务场景，用更智能的调度系统、更丰富的服务品类、更贴心的人文关怀，服务好每一个在凌晨有需要的人。</p>`,
    category: 'life',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20data%20dashboard%20with%20charts%20and%20graphs%20on%20large%20screen%20at%20night%2C%20warm%20office%20lighting%2C%20business%20analytics%20visualization%2C%20professional%20setting%2C%20night%20economy%20concept%2C%20clean%20minimal%20design&width=800&height=400&seq=article-report&orientation=landscape',
    date: '2026-07-15',
    readTime: '5分钟',
    author: '凌晨不打烊研究院',
    tags: ['夜间经济', '数据报告', '行业趋势'],
  },
];

export const featuredArticles = articles.slice(0, 3);